// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"130":"222a3008","307":"ed3db585","1025":"ed3db585","2178":"ed3db585","3887":"ed3db585","4538":"ed3db585","4681":"ed3db585","8688":"af3ee84d","8881":"ed3db585","9610":"ed3db585"}[chunkId] + ".chunk.css";
};